import { useTranscript } from './queries';
import TranscriptNotFound from 'projects/components/TranscriptNotFound';

/**
 * Custom hook that wraps useTranscript and handles 404 errors
 * @param {string|number} transcriptId - The transcript ID to fetch
 * @returns {Object} Object with transcript data, error, loading state, and NotFoundComponent
 */
export function useTranscriptWithErrorHandling(transcriptId) {
  const queryResult = useTranscript(transcriptId);
  const { error: transcriptError } = queryResult;
  
  // Check for 404 or 403 in multiple ways since the error might be wrapped by API layer
  const is404or403 = transcriptError && (
    transcriptError.status === 404 || 
    transcriptError.status === 403 ||
    transcriptError.response?.status === 404 ||
    transcriptError.response?.status === 403 ||
    transcriptError.originalError?.response?.status === 404 ||
    transcriptError.originalError?.response?.status === 403 ||
    transcriptError.name === 'HTTP404Error' ||
    transcriptError.name === 'HTTP403Error'
  );
  
  // Component to render if transcript not found or forbidden
  const NotFoundComponent = is404or403 ? TranscriptNotFound : null;
  
  return {
    ...queryResult,
    is404: is404or403,
    hasError: !!transcriptError,
    NotFoundComponent
  };
}